import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { BreadcrumbItem } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';

import dynamic from 'next/dynamic';

const DesktopNavigation = dynamic(() =>
  import('./components/desktop-navigation'),
);
const MobileNavigation = dynamic(() =>
  import('./components/mobile-navigation'),
);

const ReducedNavigation = dynamic(() =>
  import('./components/reduced-navigation'),
);

export type NavProps = {
  searchConfig: {
    showSearchToggler: boolean;
    showSearchInput: boolean;
  };
  subscriptionBreadcrumbs?: BreadcrumbItem[];
};

const Nav = ({ searchConfig, subscriptionBreadcrumbs }: NavProps) => {
  const router = useRouter();
  const media = useMedia();
  const [navigationVisibility, setNavigationVisibility] = useState(false);

  // Fix for NextJS Hydration
  useEffect(() => {
    setNavigationVisibility(true);
  }, []);

  if (!navigationVisibility) {
    return <></>;
  }

  return (
    <nav>
      {router.pathname === '/checkout' ||
      router.pathname === '/download-invoice/[tripUUID]/[token]' ||
      (router.pathname === '/order-details/[id]' &&
        router.query.returning_user !== 'true') ? (
        <ReducedNavigation />
      ) : (
        <>
          {media.gtMd && (
            <DesktopNavigation
              searchConfig={searchConfig}
              subscriptionBreadcrumbs={subscriptionBreadcrumbs}
            />
          )}
          {!media.gtMd && (
            <MobileNavigation
              subscriptionBreadcrumbs={subscriptionBreadcrumbs}
            />
          )}
        </>
      )}
    </nav>
  );
};

export default Nav;
